// This ensures all dependencies (that I've written, anyway) use the same
// decimal.js version. Yeah, globals are bad, but this is so much easier than
// wrangling webpack/require, especially since create-react-app restricts what
// config we can change anyway. Immutable globals like this are less bad anyway.
import Decimal from "decimal.js"
global.Decimal = Decimal



// WEBPACK FOOTER //
// ./src/global.js